import { render } from "./PackageZhPageList.vue?vue&type=template&id=05a89c2f&scoped=true&ts=true"
import script from "./PackageZhPageList.vue?vue&type=script&lang=ts"
export * from "./PackageZhPageList.vue?vue&type=script&lang=ts"

import "./PackageZhPageList.vue?vue&type=style&index=0&id=05a89c2f&lang=sass&scoped=true"

import exportComponent from "D:\\workspace\\com.xiansheng\\MiezzGitPull\\Miezz\\Miezz.Web.Entry\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05a89c2f"]])

export default __exports__